import React, { useEffect, useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { StyledConfigurationContainer, StyledIndexContainerDiv, StyledLeadContainer } from '../../Components/Styled/index';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { privateRoutesPath } from '../../Routes';
import { GridRowModes } from '@mui/x-data-grid';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import {isValidEmail, updateRequestData } from '../../Utility/apiHelper';
import DataGridTable from '../../Components/DataGrid';
import { useDispatch, useSelector } from 'react-redux';
import { emailWidth, handleValidateCodevalue, nameWidth, phoneCountryCodes, phoneWidth, searchEntity, statusWidth, vendorIdWidth, vendorNameWidth, whocolumnWidth } from '../../Utility/constant';
import SearchVendor from './SearchVendor';
import BiztantuSearch from '../../Components/BiztantuSearch';
import { requestGetAllMerchant } from '../../Store/Merchant/action';
import BiztantuLoader from '../../Components/Loader';
import { resetState } from '../../Utility/resetSearchFunction';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { resetSearch, setSearch } from '../../Store/SearchReducer/action';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useEntitySearch } from '../../Utility/hooks/useEntitySearch';
import useNavigation from '../../Utility/hooks/useNavigation';
import './vendor.css';

const MerchantPage = ({ }) => {
  const [dataGridData, setDatagridData] = useState([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [selectionModel, setSelectionModel] = React.useState([]);
  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  const vendorData = useSelector(state => state?.merchant?.merchant);
  const currentUser = useSelector(state => state?.owner?.currentuser);
  const vendorSearch = useSelector((state) => (state.search.vendor));
      
  
    const ownerlist = useSelector(state => state?.owner?.ownerlist);  
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
    const dispatch = useDispatch();
    
    const { navigateTo } = useNavigation();
    const ownerListData = useMemo(
        () =>
            ownerlist.map(item => ({
                name: `${item.firstName} ${item.lastName}`,
                id: item.id,
            })),
        [ownerlist]
    );
    const getInitialState = () => ({
        pocPhoneCountryCode: phoneCountryCodes.pocPhoneCountryCode,
    });
    useEffect(() => {
        setownerlistdropdown(ownerListData);
    }, [ownerListData]);

           
      useEffect(() => {
      const updatedLeadTable =  (vendorData || []).map((item,index)=>{
                const countryCode = item?.pocPhoneCountryCode || "";
                const phone = item?.pocPhone || "";
                          return {
                              ...item,
                              pocPhone: countryCode && phone ? `${countryCode}${phone}` : "",
                              createdAt: moment(item.createdAt).format('MM/DD/YYYY'),
                              updatedAt: moment(item.updatedAt).format('MM/DD/YYYY'),
                          }
                      })
                      setDatagridData(updatedLeadTable);
           }, [vendorData]);

const handleChangeSearchField = (event) => {
        dispatch(setSearch(searchEntity?.vendor, {
          ...vendorSearch,
          [event.target.name]: event.target.value,
        }));
    }
      const preserveSearch = useSelector(
        state => state?.search?.preserveSearch?.[searchEntity?.vendor]
      );

      useEntitySearch({
          entity: searchEntity?.vendor,
          searchState: vendorSearch,
          getInitialState,
          preserveSearch,
          isReady : true,
          fetchAction: (params) =>
              requestGetAllMerchant({
                  params,
              }),
      });
    // when you handleReset button
    const handleResetSearch = () => {
      dispatch(
        resetSearch(searchEntity?.vendor,resetState(vendorSearch,{
              pocPhoneCountryCode : vendorSearch?.pocPhoneCountryCode
              })
            )
        );
     }

    const processRowUpdate = (newRow, oldRow) => {
            if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
              enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_NO_DATA_CHANGED'), {variant: 'info'});
            } else {
              handleUpdateMerchant(newRow); 
            }
        const updatedRow = { ...newRow, isNew: false };
        setDatagridData(dataGridData.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
          };
  const columns = [
    {
      field: 'id',
       headerName: handleValidateCodevalue(internationalise,'VEND_SEARCH_VENDOR_ID'),
      flex: 1,
      editable: false,
      minWidth: vendorIdWidth,
      renderCell : ({id})=>(
      <span
      onClick={handleEditMerchant(id,true)}
      className="vendor-id-link"
      >
          {id}
        </span>
      )
    },
    {
      field: 'name',
       headerName: handleValidateCodevalue(internationalise,'VEND_SEARCH_NAME'),
      flex: 1,
      editable: true,
      minWidth: vendorNameWidth,
    },
    {
      field: 'pocFirstName',
      headerName: handleValidateCodevalue(internationalise,'COMMON_POC_FIRSTNAME'),
      flex: 1,
      editable: true,
       minWidth: nameWidth,
    
    },
    
    {
      field: 'pocLastName',
      headerName: handleValidateCodevalue(internationalise,'COMMON_POC_LASTNAME'),
      flex: 1,
      editable: true,
       minWidth: nameWidth
    
    },
    {
      field: 'pocEmail',
      headerName: handleValidateCodevalue(internationalise,'COMMON_EMAIL_ID'),
      flex: 1,
      editable: true,
      minWidth: emailWidth,
    },
    {
      field: 'status',
       headerName: handleValidateCodevalue(internationalise,'VEND_SEARCH_STATUS'),
      flex: 1,
      minWidth: statusWidth,
      valueGetter:({value})=>{
        if(!value){
          return ""
        }
        return handleValidateCodevalue(internationalise,value)
          }
        },
    {
      field: 'pocPhone',
      headerName: handleValidateCodevalue(internationalise,'COMMON_PHONE_NUMBER'),
      flex: 1,
      editable: false,
      minWidth: phoneWidth,
    },
    {
      field: 'createdAt',
      headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
      type: 'date',
      flex: 1,
      editable: false,
      minWidth: whocolumnWidth,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
    {
      field: 'updatedAt',
      type: 'date',
      headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
      flex: 1,
      editable: false,
       minWidth: whocolumnWidth,
      valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
    },
  ];

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleEditMerchant = (id,value) => () => {
       navigateTo(`${privateRoutesPath.EDIT_MERCHANT}/${id}`,{ isViewMode: value },searchEntity?.vendor);
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = dataGridData.find((row) => row.id === id);
    if (editedRow.isNew) {
      setDatagridData(dataGridData.filter((row) => row.id !== id));
    }
  };


    const handleSearchVendor = async() => {
      try{
    const queryparams ={
      params : {
       ...vendorSearch,
       pocMobileNumber : vendorSearch?.pocPhone,
        firstName : vendorSearch?.pocFirstName,
        lastName : vendorSearch?.pocLastName
       
      }
    } 
    dispatch(requestGetAllMerchant(queryparams))
  }
  catch{

  }
  finally{
    dispatch(requestHideLoader())
  }
    }


  const handleUpdateMerchant = async (rowRecord) => {
      if(!isValidEmail(rowRecord?.pocEmail)){
      enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_EMAIL"),{variant:'error'});
      return;
      }

    const Id = rowRecord?.id;

    const { id , createdAt , updatedAt, ...UpdatedmerchantData } = rowRecord;

    const payload = {
      ...UpdatedmerchantData,
    }
    dispatch(requestShowLoader())
    try {
        await updateRequestData(payload, `vendors/${Id}`);

        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                "COMMON_UPDATED_SUCCESSFULLY"
            ),
            { variant: "success" }
        );

        handleSearchVendor();
    } catch (error) {
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                error?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
            ),
            { variant: "error" }
        );
    } finally {
        dispatch(requestHideLoader());
    }}
  
  const vendorSearchBox = {
    ...vendorSearch
  }

    const isLoadingProgress = useSelector(state => state?.global.isLoading); 
  return (
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
          <Box className="vendor-index-container">
        <StyledConfigurationContainer>
        <Typography variant='h6'>
        {handleValidateCodevalue(internationalise,'VEND_SEARCH_TITLE')}
                
        </Typography>
      </StyledConfigurationContainer>
      {/* <SearchVendor
        handleSearchVendor={handleSearchVendor}
      /> */}
      <StyledIndexContainerDiv>
        <StyledLeadContainer className="vendor-search-panel">
            <Stack className='table-header-search table-header-search-common'>
                <BiztantuSearch
                  showStatus = {false}
                  entityDetails = {vendorSearchBox}
                  ownerlistdropdown = {ownerlistdropdown}
                  handleReset = {handleResetSearch}
                  handleSearch = {handleSearchVendor}>
                    <SearchVendor
                      // handleSelectOwner = {handleSelectOwner}
                      ownerlistdropdown = {ownerlistdropdown}
                      entityDetails = {vendorSearch}
                      handleOnChange = {handleChangeSearchField}
                    />
                </BiztantuSearch>
              </Stack>
              <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                {specificRolePermission?.isVendorManage && 
                    <>
                    <Button
                    className='biztantu-sec-btn' variant="outlined" onClick={() => navigateTo(privateRoutesPath.CREATE_MERCHANT,{},searchEntity?.vendor)}>{handleValidateCodevalue(internationalise,'VEND_CREATE')}</Button>
                    </>
                    }
              </Stack>
          </StyledLeadContainer>
      
      <DataGridTable
        isCheckboxReq={false}
        dataGridData={dataGridData}
        height='calc(100vh - 270px)'
        filename="merchant"
        selectionModel={selectionModel}
        setSelectionModel={(data) => setSelectionModel(data)}
        columns={columns}
        handleProcessRowUpdate={processRowUpdate}
        rowModesModel={rowModesModel}
        handleUpdateProduct={handleUpdateMerchant}
      />
      </StyledIndexContainerDiv>
      </Box>
    </BiztantuLoader>
  )
}

export default MerchantPage;